import { useState, useEffect, useContext } from 'react'
import MainMenu from './components/MainMenu';
import Login from './components/Login';
import { BrowserRouter as Router, Route} from 'react-router-dom';

import './components/Firebase'
import MultiPlayer from './components/MultiPlayer';
import { getLeaderBoard, getRuns } from './components/Firebase';

import Firebase from './components/Firebase';
import Navbar from './components/Navbar';

import { LoginContext, UserContext } from './Context/Context';
import Lobby from './components/Lobby';

import Game from './components/Game/Game'
import Load from './components/Game/Load';
import MultiplayerGame from './components/Game/MultiplayerGame'


let loggedUser;

function App() {
  const [runs, setRuns] = useState([]) 
  const [loggedIn, setLoggedIn] = useState(false)
  const [user, setUser] = useState({})

  loggedUser = user  

  useEffect(() => {
  fetchRuns()  
  }, [])


 

  const fetchRuns = () => {
    var PromiseRuns = getRuns();

    PromiseRuns.then((res) =>{
      PromiseRuns = res
      setRuns(PromiseRuns)
    })
  }

  return (
    <Router>
    <LoginContext.Provider value={{loggedIn, setLoggedIn}}>
      <UserContext.Provider value={{user, setUser}}>
        <div className="container"  >
          <div id="particles-js"></div>
            {window.location.pathname === "/Solo" ? null : <Navbar/>}
            <Route path="/menu" exact component={MainMenu}/>
            <Route path="/" exact component={Login}/>
            <Route path="/multiplayer" render={(props) => (
              <div className="view">
                
                <MultiPlayer runs={runs} refresh={fetchRuns} />
              </div>
              )} />
            <Route path="/lobby" exact component={Lobby} />  
            <Route path="/solo" exact component={Game}/>
            <Route path="/online" exact component={MultiplayerGame} />
            <Route path="/Load" exact component={Load}/>
        </div>
        <Firebase></Firebase>
      </UserContext.Provider>
    </LoginContext.Provider >

    </Router>
  );
}

export default App;


function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function ShakeIt(form){
  var Form = document.getElementById(form); 
  Form.classList.add('SHAKE_IT_REAL_GOOD')
  await sleep(1500)
  Form.classList.remove('SHAKE_IT_REAL_GOOD')
};

export function GetUser(){
  const {user, setUser} = useContext(UserContext)
  return user
}

export {loggedUser}